export const progressBarTokens = {
  'progress-height': '8px',
  'progress-height-sm': '4px',
  'progress-height-lg': '12px',
  'progress-bg': 'var(--dp-color-surface)',
  'progress-fill-color': 'var(--dp-color-primary)',
  'progress-border-radius': 'var(--dp-border-radius-full)',
  'progress-transition': '0.3s ease',
  'progress-success-color': 'var(--dp-color-success)',
  'progress-error-color': 'var(--dp-color-error)',
  'progress-warning-color': 'var(--dp-color-warning)',
} as const;
